var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',[_c('div',{staticClass:"subtitle-2"},[_vm._v(_vm._s(_vm.item))])]),_c('v-col',{staticClass:"text-right"},[_c('div',{staticClass:"subtitle-2"},[_vm._v(_vm._s(_vm.value))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }